import React from 'react';
import { CheckIcon } from 'lucide-react';
export function ValueStackSection() {
  return <section className="py-6 px-4 bg-gray-900 text-white" data-id="element-316">
      <div className="max-w-3xl mx-auto bg-gray-800 rounded-3xl p-5 md:p-8 border-4 border-yellow-400 shadow-2xl" data-id="element-317">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#F9327E] uppercase" data-id="element-318">
          Todo lo que vas a recibir hoy
        </h2>

        <div className="mb-4" data-id="element-319">
          <h3 className="text-2xl font-bold mb-3" data-id="element-320">📦 Acceso inmediato a:</h3>
          <ul className="space-y-2 text-xl pl-4" data-id="element-321">
            <li className="flex items-center font-bold" data-id="element-322">
              <span className="text-yellow-400 mr-3" data-id="element-323">•</span> Contenido
              principal Efemérides Listas
            </li>
            <li className="flex items-center" data-id="element-324">
              <span className="text-yellow-400 mr-3" data-id="element-325">•</span> BONUS 1: Glosas
              Listas
            </li>
            <li className="flex items-center" data-id="element-326">
              <span className="text-yellow-400 mr-3" data-id="element-327">•</span> BONUS 2: Actos
              Resueltos
            </li>
            <li className="flex items-center" data-id="element-328">
              <span className="text-yellow-400 mr-3" data-id="element-329">•</span> BONUS 3: Pack
              Mundial
            </li>
          </ul>
        </div>

        <div className="border-t border-gray-600 pt-4" data-id="element-330">
          <h3 className="text-2xl font-bold mb-3" data-id="element-331">Además vas a tener:</h3>
          <ul className="space-y-2 text-lg" data-id="element-332">
            <li className="flex items-start" data-id="element-333">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-334" />
              <span data-id="element-335">Explicaciones claras de cada efeméride</span>
            </li>
            <li className="flex items-start" data-id="element-336">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-337" />
              <span data-id="element-338">Actividades listas para trabajar</span>
            </li>
            <li className="flex items-start" data-id="element-339">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-340" />
              <span data-id="element-341">Material organizado para todo el año</span>
            </li>
            <li className="flex items-start" data-id="element-342">
              <CheckIcon className="w-6 h-6 text-green-400 mr-3 flex-shrink-0 mt-1" data-id="element-343" />
              <span data-id="element-344">Recursos para actos escolares</span>
            </li>
          </ul>
        </div>
      </div>
    </section>;
}